import script from "./CompletedMovesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompletedMovesPage.vue?vue&type=script&setup=true&lang=ts"

import "./CompletedMovesPage.vue?vue&type=style&index=0&id=5d6a05ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d6a05ea"]])

export default __exports__